import colors from "../../_colors.scss";

export const MAGNET_INDICATORS = Object.freeze([
  {
    label: "Child Labour & Forced Labour",
    options: [
      { value: "Children in employment, total", text: "Children In Employment" },
      { value: "Frequency of forced labour", text: "Frequency Of Forced Labour" },
      { value: "Goods produced by forced labour", text: "Goods Produced By Forced Labour" },
      { value: "Trafficking in persons", text: "Trafficking In Persons" },
    ],
    desc: [
      "Indicates the percentage of children aged 5–17 engaged in labour within a sector",
      "Indicates how common forced labour is in a country per 1,000 inhabitants",
      "Indicates the number of goods in a sector linked to forced labour practices",
      "Indicates the presence or absence of trafficking in persons, including forced labour, slavery, and slavery-like practices, within a sector",
    ],
  },
  {
    label: "Wage & Working Conditions",
    options: [
      { value: "Gender wage gap", text: "Gender Wage Gap" },
      { value: "Living wage, per month (AV)", text: "Living Wage, Per Month (AV)" },
      { value: "Minimum wage, per month", text: "Minimum Wage, Per Month" },
      { value: "Weekly hours of work per employee", text: "Weekly Hours Of Work Per Employee" },
      { value: "Violations of mandatory health and safety standards", text: "Violations Of Mandatory Health And Safety Standards" },
    ],
    desc: [
      "Indicates the percentage difference between male and female wages in a sector",
      "Evaluation of monthly income vs the monthly income required for a decent standard of living",
      "Evaluation of monthly income vs the legally mandated lowest monthly income for full-time work",
      "Indicates the average number of hours worked weekly by employees in a sector",
      "Indicates reported breaches of occupational health and safety laws",
    ],
  },
  {
    label: "Labour Rights & Representation",
    options: [
      { value: "Trade union density", text: "Trade Union Density" },
      { value: "Right of Association", text: "Right Of Association" },
      { value: "Right of Collective bargaining", text: "Right Of Collective Bargaining" },
      { value: "Right to Strike", text: "Right To Strike" },
      { value: "Presence of sufficient safety measures", text: "Presence Of Sufficient Safety Measures" },
    ],
    desc: [
      "Indicates the percentage of workers who are members of trade unions",
      "Indicates the workers' right to form and join organizations of their own choosing",
      "Indicates the  workers' right to negotiate collectively with employers on working conditions",
      "Indicates the workers' legal right to stop work to protest conditions or disputes",
      "Indicates the implementation of workplace safety protocols via OSHA violations",
    ],
  },
  {
    label: "Employment & Workforce Composition",
    options: [
      { value: "Men in the sectoral labour force", text: "Men In The Sectoral Labour Force" },
      { value: "Women in the sectoral labour force", text: "Women In The Sectoral Labour Force" },
      { value: "Evidence of violations of laws and employment regulations", text: "Evidence Of Violations Of Laws And Employment Regulations" },
      { value: "Social security expenditures", text: "Social Security Expenditures" },
      { value: "Rate of fatal accidents at workplace", text: "Rate Of Fatal Accidents At Workplace" },
      { value: "Rate of non-fatal accidents at workplace", text: "Rate Of Non-Fatal Accidents At Workplace" },
    ],
    desc: [
      "Represents the share of male workers in a specific sector",
      "Represents the share of female workers in a specific sector",
      "Indicates the frequency of legal breaches in employment practices",
      "Indicates the proportion of GDP spent on social protection programs",
      "Indicates the number of fatal workplace accidents per 100,000 employees",
      "Indicates the number of non-fatal workplace accidents per 100,000 employees",
    ],
  },
  {
    label: "Economic & Social Development",
    options: [
      { value: "Contribution of the sector to economic development", text: "Contribution Of The Sector To Economic Development" },
      { value: "Public sector corruption", text: "Public Sector Corruption" },
      { value: "Active involvement of enterprises in corruption and bribery", text: "Active Involvement Of Enterprises In Corruption And Bribery" },
      { value: "Presence of anti-competitive behaviour or violation of anti-trust and monopoly legislation", text: "Presence Of Anti-Competitive Behaviour Or Violation Of Anti-Trust And Monopoly Legislation" },
      { value: "Membership in an initiative that promotes social responsibility along the supply chain", text: "Membership In An Initiative That Promotes Social Responsibility Along The Supply Chain" },
    ],
    desc: [
      "Indicates how much a sector contributes to national GDP",
      "Indicates perceived corruption in government institutions",
      "Indicates the percentage of businesses engaged in bribery",
      "Indicates reported cases of monopolistic or unfair business practices",
      "Indicates how many companies in a sector adopt social responsibility codes",
    ],
  },
  {
    label: "Migration",
    options: [
      { value: "Emigration rate", text: "Emigration Rate" },
      { value: "Immigration rate", text: "Immigration Rate" },
      { value: "International migrant workers in the sector", text: "International Migrant Workers In The Sector" },
      { value: "Number of asylum seekers in relation to total population", text: "Number Of Asylum Seekers In Relation To Total Population" },
    ],
    desc: [
      "Compares the rate of people leaving a country",
      "Compares the rate of people entering a country",
      "Indicates the percentage of migrant workers in a sector",
      "Indicates the number of asylum seekers relative to the population",
    ],
  },
  {
    label: "Education & Literacy",
    options: [
      { value: "Illiteracy rate, total", text: "Illiteracy Rate" },
      { value: "Public expenditure on education", text: "Public Expenditure On Education" },
    ],
    desc: [
      "Indicates the percentage of adults unable to read or write",
      "Indicates the percentage of GDP allocated to education",
    ],
  },
  {
    label: "Health & Wellbeing",
    options: [
      { value: "Health expenditure, total", text: "Health Expenditure" },
      { value: "Life expectancy at birth", text: "Life Expectancy At Birth" },
      { value: "Workers affected by natural disasters", text: "Workers Affected By Natural Disasters" },
      { value: "Sanitation coverage", text: "Sanitation Coverage" },
    ],
    desc: [
      "Indicates the health spending by source and total share of GDP",
      "Indicates the average lifespan expected for newborns",
      "Indicates the percentage of workers impacted by environmental disasters",
      "Indicates the percentage of the population with access to adequate sanitation",
    ],
  },
  {
    label: "Indigenous & Minority Rights",
    options: [
      { value: "Indigenous People Rights Protection Index", text: "Indigenous People Rights Protection Index" },
      { value: "Presence of indigenous population", text: "Presence Of Indigenous Population" },
    ],
    desc: [
      "Indicates the level of  the legal and practical protection of indigenous rights",
      "Indicates the presence of indigenous communities in a country",
    ],
  },
]);

export const RISK_LEVELS = Object.freeze(["very low risk", "low risk", "medium risk", "high risk", "very high risk", "no data"]);
export const OPPORTUNITY_LEVELS = Object.freeze(["high opportunity", "medium opportunity", "low opportunity", "no opportunity"]);

export const RISK_COLOR_MAP = Object.freeze({
  "very low risk": colors.riskVeryLow,
  "low risk": colors.riskLow,
  "medium risk": colors.riskMedium,
  "high risk": colors.riskHigh,
  "very high risk": colors.riskVeryHigh,
  "no opportunity": colors.opportunityNo,
  "low opportunity": colors.opportunityLow,
  "medium opportunity": colors.opportunityMedium,
  "high opportunity": colors.opportunityHigh,
  "no data": colors.greyDark,
});

export const RISK_LEVEL_ORDER = Object.freeze({
  "very high risk": 5,
  "high risk": 4,
  "medium risk": 3,
  "low risk": 2,
  "very low risk": 1,
  "no data": 0.05,
});

export const OPPORTUNITY_LEVEL_ORDER = Object.freeze({
  "high opportunity": 3,
  "medium opportunity": 2,
  "low opportunity": 1,
  "no opportunity": 0.05,
});

export const MAGNET_SCENARIOS = Object.freeze(["baseline", "SSP1", "SSP2", "SSP3"]);
export const MAGNET_YEARS = Object.freeze([2030, 2050]);
